import { Component } from '@angular/core';
import { Application } from '@modules/common/types/application';
import { SidebarSplitViewKey } from '@modules/common/types/sidebar-split-view-key';

@Component({
  selector: 'app-contacts-layout',
  templateUrl: './contacts-layout.component.html',
  styleUrls: ['./contacts-layout.component.less', '../../styles.less'],
  standalone: false,
})
export class ContactsLayoutComponent {
  protected readonly sidebarSplitViewKey = SidebarSplitViewKey;
  protected readonly app = Application.contacts;
}
